import React, {useEffect} from 'react';
import classNames from 'classnames';
import {useAnimationsContext} from '../../../contexts';
import styles from './WinterImage.module.scss';

interface WinterImageProps extends Omit<React.HTMLProps<HTMLImageElement>, 'src' | 'alt'> {
  className?: string;
}

const tuningOffset = 750;

const WinterImage = ({className, ...props}: WinterImageProps) => {
  const {animationDuration, animations} = useAnimationsContext();

  useEffect(() => {
    if (animations.winter.isOpen) {
      setTimeout(animations.winter.hide, animationDuration - tuningOffset);
    }
  }, [animations.winter.isOpen]);

  return animations.winter.isOpen && (
    <img src={animations.winter.image} alt="winter" className={classNames(styles.image, className)} {...props} />
  );
};

export default WinterImage;